module.exports = __webpack_public_path__ + "img/nordic_yes-38ppK5_.svg";